// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import jest from "./assets/techstack/jest.png";
import materialui from "./assets/techstack/materialui.png";
import apigateway from "./assets/techstack/api-gateway.png";
import lambda from "./assets/techstack/lambda.png";
import dynamodb from "./assets/techstack/dynamodb.png";
import s3 from "./assets/techstack/s3.png";
import cloudfront from "./assets/techstack/cloudfront.png";
import cloudwatch from "./assets/techstack/cloudwatch.png";
import sns from "./assets/techstack/sns.png";
import ses from "./assets/techstack/ses.png";
import mongodb from "./assets/techstack/mongodb.png";
import nodejs from "./assets/techstack/node-js.png";
import expressjs from "./assets/techstack/express-js.png";
import docker from "./assets/techstack/docker.png";
import postgre from "./assets/techstack/postgre.png";
import typescript from "./assets/techstack/typescript.png";
import go from "./assets/techstack/go.png";

// Porject Images
import projectImage1 from "./assets/projects/fit-graph-card.png";
import projectImage2 from "./assets/projects/health-tracker.png";
import projectImage3 from "./assets/projects/rps.png";
import projectImage4 from "./assets/projects/aquamind-back-drop.png";
import projectImage5 from "./assets/projects/helixstream.png";
import projectImage6 from "./assets/projects/IoT.png";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Steven Stansberry",
  img: profile,
  about: `I am an aspiring software engineer with a passion for creating innovative, real-world applications that leverage cutting-edge technology and a strong foundation in cloud computing and AI. My focus is on full-stack development using Go for building scalable, high-performance backend systems, PostgreSQL for robust data management, and Docker for containerization to streamline development and deployment. I am also proficient with React for creating modern, responsive frontend interfaces, and Node.js and Express.js for building flexible and efficient APIs. My cloud expertise includes orchestrating infrastructure with AWS EKS, AWS Lambda, and API Gateway, ensuring that applications are scalable, resilient, and secure. I also work with DynamoDB for managing large-scale, distributed databases. My goal is to build data-driven solutions that enhance user experience and solve practical problems, with a focus on modern cloud, DevOps, and AI integration.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/steven-stansberry",
  github: "https://github.com/stevenpstansberry",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Frontend Web Developer",
    Company: `Company Name here`,
    Location: "Bengaluru",
    Type: "Full Time",
    Duration: "Sep 2021 - Dec 2021",
  },
  {
    Position: "Internship",
    Company: `Company Name here`,
    Location: "Bengaluru",
    Type: "Internship",
    Duration: "Sep 2021 - Dec 2021",
  },
  {
    Position: "Internship",
    Company: `Company Name here`,
    Location: "Bengaluru",
    Type: "Internship",
    Duration: "Sep 2021 - Dec 2021",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelor of Science in Software Engineering",
    Company: "San José State University",
    Location: "San José, CA",
    Type: "Full Time",
    Duration: "Graduated May 2024",
  },
];

export const certDetails = [
  {
    Position: "AWS Certified Developer - Associate",
    Duration: "July 2024",
    Link: "https://www.credly.com/badges/eb2e5d53-047b-4307-bb0d-b1f6a5f92ba1",
  },
  {
    Position: "AWS Certified Cloud Practitioner",
    Duration: "June 2024",
    Link: "https://www.credly.com/badges/c4f40c6a-2e83-4e49-a4ec-992511d913bb",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  jest: jest,
  materialui: materialui,
  apigateway: apigateway,
  lambda: lambda,
  dynamodb: dynamodb,
  s3: s3,
  cloudfront: cloudfront,
  cloudwatch: cloudwatch,
  sns: sns,
  ses: ses,
  mongodb: mongodb,
  nodejs: nodejs,
  expressjs: expressjs,
  docker: docker,
  postgre: postgre,
  typescript: typescript,
  go: go,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "AquaMind",
    image: projectImage4,
    description: `Aquamind is an innovative aquarium management app using Go microservices, Kubernetes, and AWS for scalability, with PostgreSQL for data storage. The platform offers AI-powered insights and real-time monitoring to optimize aquarium health. Its React-built interface allows users to log water parameters, track species, and receive personalized care recommendations. GPT-4 integration powers an AI assistant that helps users manage aquarium ecosystems with tailored advice and expert guidance.`,
    techstack:
      "React, Go Microservices, PostgreSQL, Amazon EKS, Amazon ECS, Kubernetes, Docker, S3, Amazond RDS, SQL, GPT-4",
    previewLink: "https://aquamind.fish",
    githubLink: "https://github.com/stevenpstansberry/AquaMind-AI",
  },
  {
    title: "HelixStream",
    image: projectImage5,
    description: `HelixStream: Designed and implemented a scalable bioinformatics pipeline on AWS, leveraging BioPython and cron jobs to automate the 
    ingestion, sanitization, and preparation of 100+ monthly biotechnology database records. Streamlined data sanitization on EC2 instances using UNIX, 
    Bash, and Clustal Omega for large-scale viral sequence alignment, cutting manual handling time by 47%. Automated data deployment to S3 via 
    AWS CLI scripts and developed Spring Boot API endpoints to coordinate cron job execution and analysis workflows.`,
    techstack:
      "AWS (EC2, S3, CLI), IoT, Extract, Load, Transform (ETL), Data Pipeline, BioPython, UNIX, Bash, Clustal Omega, Spring Boot, Cron Jobs",
    previewLink: "https://www.helixstream-demo.com/",
    githubLink: "https://github.com/stevenpstansberry/HelixStream",
  },
  {
    title: "Fit Graph Pro",
    image: projectImage1,
    description: `Fit Graph Pro is a workout tracking web application built with React and AWS cloud services. 
    It allows users to log workouts, visualize progress through interactive graphs, and track muscle activity using a body heatmap. 
    The app predicts future performance using a linear regression model based on workout history, 
    and the back-end is powered by AWS Lambda, DynamoDB, and API Gateway. 
    User authentication is handled securely with JWT.`,
    techstack:
      "React, Lambda, API Gateway, node.js,DynamoDB, S3, CloudFront, CloudWatch, SES, SNS, Jest, Material-UI, HTML/CSS",
    previewLink: "https://fitgraphpro.com/",
    githubLink: "https://github.com/stevenpstansberry/fit-graph-pro",
  },
  {
    title: "IoT HealthSync",
    image: projectImage6,
    description: `This project focuses on designing and deploying a scalable, 
    secure IoT system for real-time monitoring of patient vitals such as heart rate, 
    oxygen saturation, and temperature. The system incorporates Kafka for data ingestion, 
    Redis for low-latency storage, AWS Lambda functions and EC2 for compute orchestration, 
    and Amazon S3 for secure data archiving. Enhanced with Linux-based tools, VPC for 
    network isolation, and IAM roles for fine-grained access control, it adheres to FHIR standards 
    for healthcare interoperability and demonstrates proficiency in IoT systems, 
    cloud orchestration, and system-level monitoring.`,
    techstack:
      "IoT, Linux Bash scripts, netcat, Apache Kafka, TCP sockets, VPC, Redis, Amazon S3, AWS Lambda, EC2 , Spring Boot, SSL/TLS protocols, IAM roles, AWS CloudWatch, FHIR/HIPAA standards, Python, S3 Lambda Access Points",
    previewLink: "",
    githubLink: "https://github.com/stevenpstansberry/iot-health-sync",
  },
  {
    title: "Raspberry Pi Enviornmental Health Tracker and Dashboard",
    image: projectImage2,
    description: `This web app uses an embedded Raspberry Pi system and sensors (DHT22, BME280, SGP40) to monitor temperature, humidity, air quality, and pressure. 
    It collects and uploads data to MongoDB every 10 minutes, with real-time and historical insights displayed on an interactive dashboard. 
    Metrics like dew point and heat index are also calculated.`,
    techstack:
      "IoT, MongoDB, Embedded Systems, Raspberry Pi, Python, JavaScript, HTML/CSS",
    previewLink: "",
    githubLink:
      "https://github.com/stevenpstansberry/raspberry-pi-environmental-health-tracker",
  },

  {
    title: "Visionary RPS",
    image: projectImage3,
    description: `Visionary-RPS is a computer vision based game that allows users to play Rock-Paper-Scissors against the computer using hand gestures. It leverages computer vision via the OpenCV library and MediaPipe for hand tracking, providing a seamless, gesture-based gameplay experience.`,
    techstack: "OpenCV, MediaPipe, Python, Pillow, Tkinter",
    previewLink: "",
    githubLink: "https://github.com/stevenpstansberry/Visionary-RPS",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "stevenpstansberry@gmail.com",
};
